<template>
    <div class="container shifts-template-index-container">
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="card-header-label col-2">
                        <span class="mdi mdi-calendar-clock custom-icon"
                        ></span>
                        <span>Plantillas de turno</span>
                    </div>
                    <div class="card-header-search-bar col-5">
                        <b-form-input
                            v-model="filter"
                            id="filter-input"
                            placeholder="Escriba aquí el texto a buscar"
                        />
                    </div>
                    <div class="card-header-pagination col-3">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="filteredList ? filteredList.length : 0"
                            :per-page="perPage"
                            style="margin: 0"
                            align="center"
                        >
                        </b-pagination>
                    </div>
                    <div class="card-header-action-buttons col-2">
                        <div>
                            <ButtonComponent
                                v-if="canCreateShiftTemplate"
                                :buttonText="'Nuevo'"
                                :buttonColor="colors.GREEN_COLOR_BUTTON"
                                :buttonAction="openCreateModal"
                            />
                            <ButtonComponent
                                :buttonText="'Refrescar'"
                                :buttonColor="colors.BLUE_COLOR_BUTTON"
                                :buttonAction="refreshShiftsTemplates"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="isLoading" style="padding: 5ch 0;">
                <SpeenComponent  
                    :isAutomatic="true" 
                    :ringWidth="14" 
                    :spinnerSize="15" 
                    :isverticalAligned="true"
                />
            </div>
            <div class="card-body" v-else>
                <template>
                    <b-table 
                        id="shifts-templates-index-table" 
                        striped 
                        hover 
                        :items="filteredList" 
                        :fields="fields" 
                        responsive 
                        :per-page="perPage" 
                        :current-page="currentPage"
                        >
                        <template v-slot:cell(actions)="data">
                            <ButtonComponent
                                v-if="data.item"
                                :buttonText="canEditShiftTemplate ? 'Editar' : 'Ver'"
                                :buttonColor="colors.GREEN_COLOR_BUTTON"
                                :buttonAction="() => goToShiftTemplateEdit(data.item.id)"
                            />
                            <ButtonComponent
                                v-if="data.item && canDeleteShiftTemplate"
                                :buttonText="'Borrar'"
                                :buttonColor="colors.RED_COLOR_BUTTON"
                                :buttonAction="() => confirmDeleteShiftTemplate(data.item)"
                            />
                        </template>
                    </b-table>
                </template>
            </div>
        </div>
        <transition name="slide-fade">
            <ShiftTemplateCreateModal
                v-if="showCreateModal"
                :weekdays="weekdays"
                @shift-template-created="refreshShiftsTemplates"
                @close-modal="closeCreateModal"
            />
            <ActionConfirmModal
                v-if="showActionConfirmModal"
                :contentMessage="contentMessage"
                :close-modal="closeActionConfirmModal"
                :methodForProp="methodForProp"
            />
        </transition>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../../common/utils';
import SpeenComponent from '../../../common/components/SpeenComponent.vue';
import PermissionConsts from '../../../common/permissions';
import ButtonComponent from '../../../common/components/ButtonComponent.vue';
import Colors from '../../../common/colors';
import { filterList } from '../../../common/utils';
import ActionConfirmModal from '../../../common/components/modals/ActionConfirmModal.vue';
import ShiftTemplateCreateModal from '../components/ShiftTemplateCreateModal.vue';

export default {
    name: 'ShiftsTemplateIndex',
    components: {
        SpeenComponent,
        ButtonComponent,
        ActionConfirmModal,
        ShiftTemplateCreateModal,
    },
    data() {
        return {
            shiftTemplates: [],
            formDataShiftTemplate: {
                production_line_id: 0,
                weekday_id: 0,
                start_time: '',
                end_time: '',
                description: '',
            },
            currentPage: 1,
            perPage: 10,
            showCreateModal: false,
            isLoading: true,
            colors: Colors,
            filter: '',
            showActionConfirmModal: false,
            contentMessage: '',
            methodForProp: null,
            fields: [
                { key: 'production_line_name', label: 'Línea de producción', sortable: true, thStyle: { width: '20%' }, tdStyle: { width: '20%' } },
                { key: 'weekday_name',         label: 'Día de la semana',    sortable: true, thStyle: { width: '13.75%' }, tdStyle: { width: '13.75%' } },
                { key: 'start_time',           label: 'Hora de inicio',      sortable: true, thStyle: { width: '13.75%' }, tdStyle: { width: '13.75%' } },
                { key: 'end_time',             label: 'Hora de fin',         sortable: true, thStyle: { width: '13.75%' }, tdStyle: { width: '13.75%' } },
                { key: 'description',          label: 'Descripción',         sortable: true, thStyle: { width: '13.75%' }, tdStyle: { width: '13.75%' } },
                { key: 'stops_templates_count',label: 'Cantidad de paradas', sortable: true, thStyle: { width: '13%' }, tdStyle: { width: '13%' } },
                { key: 'actions',              label: 'Acciones',                            thStyle: { width: '12%' }, tdStyle: { width: '12%' } },
            ],
        };
    },
    methods: {
        startingApiCalls() {
            this.getShiftsTemplate();
        },
        getShiftsTemplate() {
            axios.get('/api/shifts-template/with-relation-names')
                .then(response => {
                    this.shiftTemplates = response.data;
                })
                .catch(error => {
                    console.log(error);
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        confirmDeleteShiftTemplate(shiftTemplate) {
            this.contentMessage = `¿Está seguro de que desea eliminar la plantilla de turno ${shiftTemplate.production_line_name}?`;
            this.methodForProp = () => {
                this.deleteShiftTemplate(shiftTemplate.id);
            };
            this.openActionConfirmModal();
        },
        deleteShiftTemplate(id) {
            axios.delete(`/api/shifts-template/${id}`)
                .then(response => {
                    this.getShiftsTemplate();
                    showCustomSuccessSweetAlert('Plantilla de turno eliminada correctamente');
                })
                .catch(error => {
                    console.log(error);
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.refreshShiftsTemplates();
                    this.closeActionConfirmModal();
                });
        },
        refreshShiftsTemplates() {
            this.isLoading = true;
            this.getShiftsTemplate();
        },
        openCreateModal() {
            this.showCreateModal = true;
        },
        closeCreateModal() {
            this.showCreateModal = false;
        },
        goToShiftTemplateEdit(shiftTemplateId) {
            window.location.href = `/calendar/shifts-templates/${shiftTemplateId}/edit`;
        },
        openActionConfirmModal() {
            this.showActionConfirmModal = true;
        },
        closeActionConfirmModal() {
            this.showActionConfirmModal = false;
        },
    },
    computed: {
        ...mapGetters(['userPermissions','userHasPermission']),
        filteredList() {
            return filterList(this.shiftTemplates, this.fields, this.filter);
        },
        canCreateShiftTemplate() {
            return this.userHasPermission(PermissionConsts.SHIFTS_TEMPLATE_STORE);
        },
        canEditShiftTemplate() {
            return this.userHasPermission(PermissionConsts.SHIFT_TEMPLATE_EDIT_VIEW) && this.userHasPermission(PermissionConsts.SHIFTS_TEMPLATE_ADMON_UPDATE);
        },
        canDeleteShiftTemplate() {
            return this.userHasPermission(PermissionConsts.SHIFTS_TEMPLATE_ADMON_DELETE);
        },
    },
    mounted() {
        this.startingApiCalls();
    }
};
</script>